<script>
import Vue from 'vue'
import moment from 'moment'
import { MODAL } from '@constants/Text'
import { GlobalBus } from '@services/bus'

export default {
  name: 'WalletCustomDate',
  data() {
    return {
      busModal: new Vue(),
      localDataInicio: '',
      localDataFim: '',
      inputInicio: '',
      inputFim: '',
      applied: false,
      callback: null,
      onCancel: null,
    }
  },
  computed: {
    maxDateBR() {
      return moment().format('DD/MM/YYYY')
    },
    hasAnyDate() {
      return !!(this.localDataInicio || this.localDataFim)
    },
    isInicioFuture() {
      if (!this.localDataInicio) return false
      return moment(this.localDataInicio).isAfter(moment(), 'day')
    },
    isFimFuture() {
      if (!this.localDataFim) return false
      return moment(this.localDataFim).isAfter(moment(), 'day')
    },
    isInicioAfterFim() {
      if (!this.localDataInicio || !this.localDataFim) return false
      return (
        moment(this.localDataInicio).diff(moment(this.localDataFim), 'days') > 0
      )
    },
    isRangeValid() {
      if (!this.hasAnyDate) return false
      if (this.isInicioFuture) return false
      if (this.isFimFuture) return false
      if (this.isInicioAfterFim) return false
      return true
    },
    inicioErrorMessage() {
      if (this.isInicioFuture) return 'Data de início não pode ser futura.'
      if (this.isInicioAfterFim) {
        return 'Data de início deve ser anterior a data de fim.'
      }
      return ''
    },
    fimErrorMessage() {
      if (this.isFimFuture) return 'Data de fim não pode ser futura.'
      return ''
    },
  },
  created() {
    GlobalBus.$on(MODAL.CONSOLIDADOR_WALLET_CUSTOM_DATE, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.CONSOLIDADOR_WALLET_CUSTOM_DATE, this.open)
    this.busModal.$destroy()
  },
  methods: {
    clear() {
      this.applied = false
      this.callback = null
      this.onCancel = null
      this.localDataInicio = ''
      this.localDataFim = ''
      this.inputInicio = ''
      this.inputFim = ''
    },
    open({
      callback = null,
      onCancel = null,
      initialDataInicio = '',
      initialDataFim = '',
    } = {}) {
      this.clear()
      this.callback = callback
      this.onCancel = onCancel
      this.localDataInicio = initialDataInicio || ''
      this.localDataFim = initialDataFim || ''
      this.inputInicio = this.formatToBR(this.localDataInicio)
      this.inputFim = this.formatToBR(this.localDataFim)
      this.busModal.$emit('dialog', true)
    },
    handleInputInicio(value) {
      this.inputInicio = value || ''
      this.localDataInicio = this.formatToISO(this.inputInicio)
    },
    handleInputFim(value) {
      this.inputFim = value || ''
      this.localDataFim = this.formatToISO(this.inputFim)
    },
    apply() {
      if (!this.isRangeValid) return
      if (typeof this.callback === 'function') {
        this.callback({
          dataInicio: this.localDataInicio || null,
          dataFim: this.localDataFim || null,
        })
      }
      this.applied = true
      this.busModal.$emit('dialog', false)
    },
    handleClose() {
      if (this.applied) return
      if (typeof this.onCancel === 'function') this.onCancel()
    },
    clearDates() {
      this.localDataInicio = ''
      this.localDataFim = ''
      this.inputInicio = ''
      this.inputFim = ''
    },
    formatToBR(isoValue) {
      if (!isoValue) return ''
      const parsed = moment(isoValue, 'YYYY-MM-DD', true)
      if (parsed.isValid()) return parsed.format('DD/MM/YYYY')
      const fallback = moment(isoValue)
      return fallback.isValid() ? fallback.format('DD/MM/YYYY') : ''
    },
    formatToISO(brValue) {
      if (!brValue) return ''
      const parsed = moment(brValue, 'DD/MM/YYYY', true)
      return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    centerAndDecreasesPadding
    maxWidth="550px"
    closeColor="#8e8e8e"
    backgroundColor="white"
    @close="handleClose"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">Selecionar período</span>
      </div>

      <div class="modal-content">
        <v-row>
          <v-col cols="6" sm="12" class="py-1">
            <input-by-type
              type="date_new_ux"
              label-external="Início"
              :value="inputInicio"
              :max-date="maxDateBR"
              @input="handleInputInicio"
            />
            <span
              v-if="inicioErrorMessage"
              class="wallet-custom-date__error text-xxs"
            >
              {{ inicioErrorMessage }}
            </span>
          </v-col>

          <v-col cols="6" sm="12" class="py-1">
            <input-by-type
              type="date_new_ux"
              label-external="Fim"
              :value="inputFim"
              :max-date="maxDateBR"
              @input="handleInputFim"
            />
            <span
              v-if="fimErrorMessage"
              class="wallet-custom-date__error text-xxs"
            >
              {{ fimErrorMessage }}
            </span>
          </v-col>
        </v-row>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton dark outline :disabled="!hasAnyDate" @click="clearDates">
        Limpar
      </BaseButton>
      <BaseButton primary :disabled="!isRangeValid" @click="apply">
        Filtrar
      </BaseButton>
    </template>
  </BaseModal>
</template>

<style lang="sass" scoped>
.wallet-custom-date
  &__error
    color: var(--error)
    margin-top: 4px
    display: block
</style>
